import axios from 'axios'
// Rest API endpointit funktioina
const getOutdoor = async params => {
  const response = await axios.post('/api/search/ulkoilma', params)
  return response.data
}

const getIndoor1 = async params => {
  let url = `/api/search/${params.url}`
  const response = await axios.post(url, params)
  return response.data
}

const getRadiation = async (lat, lon, peakPower, systemCost, interest, life) => {
  let url = '/api/getRadiation'
  const body = { lat, lon, peakPower, systemCost, interest, life }
  const response = await axios.post(url, body)
  return response.data
}

const getSmarctic1 = async params => {
  let url = `/api/search/${params.url}`
  const response = await axios.post(url, params)
  return response.data
}


export default { getOutdoor, getIndoor1, getRadiation, getSmarctic1 }